import { CreateAnswerDto, WorkerInfo } from '@/types/workerInfo.types';
import { api } from '../axios';

export interface WorkerInfoResponse {
  success: boolean;
  data: WorkerInfo;
}

class WorkerInfoService {
  async getWorkerInfo(workerId: string): Promise<WorkerInfoResponse> {
    const { data } = await api.get<WorkerInfoResponse>(`/workers/${workerId}/cv`);
    return data;
  }

  async createOrUpdateAnswer(data: CreateAnswerDto) {
    return api.post('/answers', data);
  }

  async getMockWorkerInfo(): Promise<{ success: boolean; data: WorkerInfo }> {
    await new Promise((resolve) => setTimeout(resolve, 800));

    return {
      success: true,
      data: {
        id: '9f38f50d-96ae-4fff-b232-d608fb7bf61e',
        createdAt: '2026-02-12T04:58:59.193Z',
        updatedAt: '2026-02-12T04:58:59.193Z',
        deletedAt: null,
        email: 'john.doe@example.com',
        firstName: 'John',
        lastName: 'Doe',
        phone: '+1-555-0101',
        bio: 'Experienced full-stack developer with 8 years building scalable web applications',
        address: null,
        city: 'New York',
        country: 'USA',
        dateOfBirth: null,
        profileImage: null,
        isActive: true,
        cvCompleted: true,
        role: 'worker',
        answers: [],
      },
    };
  }
}

export const workerInfoService = new WorkerInfoService();
